import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  createInterviewAPI,
  getInterviewsAPI,
  getInterviewByIdAPI,
  getInterviewBySessionAPI,
  updateInterviewAPI,
  submitInterviewResultsAPI,
  updateInterviewStatusAPI,
  deleteInterviewAPI,
  getInterviewStatisticsAPI
} from './interviewAPI';

// Create new interview session
export const createInterview = createAsyncThunk(
  'interview/create',
  async (interviewData, { rejectWithValue }) => {
    try {
      const response = await createInterviewAPI(interviewData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to create interview session'
      );
    }
  }
);

// Fetch all interviews for the user
export const fetchInterviews = createAsyncThunk(
  'interview/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getInterviewsAPI();
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to fetch interviews'
      );
    }
  }
);

// Fetch interview by ID
export const fetchInterviewById = createAsyncThunk(
  'interview/fetchById',
  async (interviewId, { rejectWithValue }) => {
    try {
      const response = await getInterviewByIdAPI(interviewId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to fetch interview'
      );
    }
  }
);

// Fetch interview by session ID
export const fetchInterviewBySession = createAsyncThunk(
  'interview/fetchBySession',
  async (sessionId, { rejectWithValue }) => {
    try {
      const response = await getInterviewBySessionAPI(sessionId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to fetch interview session'
      );
    }
  }
);

// Update interview configuration
export const updateInterview = createAsyncThunk(
  'interview/update',
  async ({ interviewId, updateData }, { rejectWithValue }) => {
    try {
      const response = await updateInterviewAPI(interviewId, updateData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to update interview'
      );
    }
  }
);

// Submit interview results
export const submitInterviewResults = createAsyncThunk(
  'interview/submitResults',
  async ({ interviewId, resultsData }, { rejectWithValue }) => {
    try {
      const response = await submitInterviewResultsAPI(interviewId, resultsData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to submit interview results'
      );
    }
  }
);

// Update interview status
export const updateInterviewStatus = createAsyncThunk(
  'interview/updateStatus',
  async ({ interviewId, status }, { rejectWithValue }) => {
    try {
      const response = await updateInterviewStatusAPI(interviewId, status);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to update interview status'
      );
    }
  }
);

// Delete interview
export const deleteInterview = createAsyncThunk(
  'interview/delete',
  async (interviewId, { rejectWithValue }) => {
    try {
      const response = await deleteInterviewAPI(interviewId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to delete interview'
      );
    }
  }
);

// Fetch interview statistics
export const fetchInterviewStatistics = createAsyncThunk(
  'interview/fetchStatistics',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getInterviewStatisticsAPI();
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to fetch statistics'
      );
    }
  }
);